import { MethodFn } from 'yoshi-flow-bm-runtime';
import { WidgetRegistry } from '@services/widget-registry';
import { WIDGET_REGISTRY_PROP } from '@consts';
import { Widget } from '@wix/business-dashboard-common';

type MethodParams = Parameters<MethodFn>;
type RegisterFunction = (params: MethodParams[0], args: Widget) => ReturnType<MethodFn>;

const registerWidget: RegisterFunction = ({ module }, { bmComponentName, widgetId }) => {
  if (!module[WIDGET_REGISTRY_PROP]) {
    module[WIDGET_REGISTRY_PROP] = new WidgetRegistry();
  }

  const widgetRegistry: WidgetRegistry = module[WIDGET_REGISTRY_PROP];

  widgetRegistry.registerWidget(bmComponentName, widgetId);
};

export default registerWidget;
